<script>
    export default {
        data() {
            return {
                reasonsFilter: '',
                reasonsTypes: {},
                reasons: {}
            }
        },

        created() {
            axios.get('/qms/reasons-types')
                .then(({data}) => this.reasonsTypes = data);

            axios.get('/qms/reason')
                .then(({data}) => this.reasons = data);
        },

        methods: {
            filter() {
                axios.get(`/qms/reason?type=${this.reasonsFilter}`)
                    .then(({data}) => this.reasons = data );
            }
        }
    }
</script>
